import React from 'react'

export default function ContentFirst({ orders }) {
    console.log("Orders in ContentFirst:", orders);
    return (
        <div className="container-fluid">
            <div className="row">
                {/* <!-- Earnings (Monthly) Card Example --> */}
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-primary shadow h-100 py-2">
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-primary text-uppercase mb-1 ml-3">
                                        Total Orders</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800 ml-3">{orders?.total_orders}</div>
                                </div>
                                <div className="col-auto mr-3">
                                    <i className="fas fa-calendar fa-2x text-gray-300"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Earnings (Monthly) Card Example --> */}
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-success shadow h-100 py-2">
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col">
                                    <div className="text-xs ml-2 font-weight-bold text-success text-uppercase mb-1 ml-3">
                                        Today's Orders</div>
                                    <div className="h5 ml-2 mb-0 font-weight-bold text-gray-800 ml-3">{orders?.todays_orders}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-eye fa-2x text-gray-300 mr-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Earnings (Monthly) Card Example --> */}
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-warning shadow h-100 py-2">
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col">
                                    <div className="text-xs font-weight-bold text-warning text-uppercase mb-1 ml-2">Pending Orders
                                    </div>
                                    <div className="row no-gutters align-items-center">
                                        <div className="col-auto">
                                            <div className="h5 mb-0 ml-3 mr-2 font-weight-bold text-gray-800 ml-3">{orders?.pendindg_orders}</div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-clipboard-list fa-2x text-gray-300 mr-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <!-- Pending Requests Card Example --> */}
                <div className="col-xl-3 col-md-6 mb-4">
                    <div className="card border-left-danger shadow h-100 py-2">
                        <div className="card-body">
                            <div className="row no-gutters align-items-center">
                                <div className="col mr-2">
                                    <div className="text-xs font-weight-bold text-danger text-uppercase mb-1 ml-3">
                                        Canceled Orders</div>
                                    <div className="h5 mb-0 font-weight-bold text-gray-800 ml-3">{orders?.canceled_orders}</div>
                                </div>
                                <div className="col-auto">
                                    <i className="fas fa-comments fa-2x text-gray-300 mr-3"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
